<template>
  <div class="app vh-100">
    <div class="container vh-100">
      <b-row class="justify-content-center align-items-center vh-100">
        <b-col md="4">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <label style="font-size: 16px; text-align: center">Password details sent to your email.</label>
                  <p></p>
                  <a> Password reset instructions has been sent to your registered email address. </a>
                </b-form>
                Go to<router-link class="btn btn-link" to="/login">Login</router-link>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PasswordReset'
}
</script>

<style scoped>

</style>
